import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { IdMap } from "@gtmhub/util";
import { Assignee } from "@webapp/assignees/models/assignee.models";

/**
 * Creates a custom validator specifically for the ownerIds field in the create-okr-form,
 * checking if the selected values are of the allowed type according to the session methodology.
 */
export const createOwnersTypeValidator = (getAllowedAssigneeType: () => string, getAssingeesMap: () => IdMap<Assignee>): ValidatorFn => {
  return (control: AbstractControl<string[]>): ValidationErrors | null => {
    const selectedOwners = (control.value || []).map((ownerId) => getAssingeesMap()[ownerId]);

    if (getAllowedAssigneeType() === "team" && selectedOwners.some((owner) => owner?.type === "user")) {
      return { usersCannotBeOwners: true };
    }

    if (getAllowedAssigneeType() === "user" && selectedOwners.some((owner) => owner?.type === "team")) {
      return { teamsCannotBeOwners: true };
    }

    return null;
  };
};
